var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphic2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 9H13.75C13.8875 9 14 8.8875 14 8.75V1.25C14 1.1125 13.8875 1 13.75 1H13.25C13.1125 1 13 1.1125 13 1.25V8.75C13 8.8875 13.1125 9 13.25 9ZM10.25 9H10.75C10.8875 9 11 8.8875 11 8.75V4.25C11 4.1125 10.8875 4 10.75 4H10.25C10.1125 4 10 4.1125 10 4.25V8.75C10 8.8875 10.1125 9 10.25 9ZM4.25 9H4.75C4.8875 9 5 8.8875 5 8.75V6.25C5 6.1125 4.8875 6 4.75 6H4.25C4.1125 6 4 6.1125 4 6.25V8.75C4 8.8875 4.1125 9 4.25 9ZM7.25 9H7.75C7.8875 9 8 8.8875 8 8.75V2.25C8 2.1125 7.8875 2 7.75 2H7.25C7.1125 2 7 2.1125 7 2.25V8.75C7 8.8875 7.1125 9 7.25 9ZM15.75 11H1V0.25C1 0.111875 0.888125 0 0.75 0H0.25C0.111875 0 0 0.111875 0 0.25V11.5C0 11.7762 0.22375 12 0.5 12H15.75C15.8881 12 16 11.8881 16 11.75V11.25C16 11.1119 15.8881 11 15.75 11Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic2);
export default __webpack_public_path__ + "static/media/graphic2.1cc1162d62dfc618d89ecd70568e8316.svg";
export { ForwardRef as ReactComponent };